import { schema } from 'normalizr';

const ApplicationDataTabVariableConfigurationSchema = new schema.Entity('applicationDataTabVariableConfigurations');

export default ApplicationDataTabVariableConfigurationSchema;
